var MDB = window.MDB || {};;
MDB.DPO = MDB.DPO || {};
MDB.DPO.Contacts = MDB.DPO.Contacts || {};

(function () {
    var _config;
    var _modal;
    var _table;

    $.extend(MDB.DPO.Contacts,
        {
            boot: function(config) {
                _config = config;

                console.log('boe!');

                _modal = $('#new-contact-modal');
                _modal.on('hide.bs.modal', function (e) { 
                 	 _modal.find('.modal-body').empty();
                });

                MDB.DPO.Contacts.initIconButtons();
                MDB.DPO.Contacts.initNewContactButton();
                
                
                _table = $('#contacts-table').DataTable(MDB.getDataTablesDefaults());
            },
            initNewContactButton: function () {
            	var btn = $('#new-contact-btn');

            	btn.click(function () {
            		MDB.DPO.Contacts.loadContactModal().done(function () {
            				MDB.Forms
            				_modal.modal('show');
        			});
            	});
            },
            initIconButtons: function() {
            	$('.dpo-icon-btn.delete').each(function(){
            		var me = $(this);

            		me.click(function(e){
            			var id = me.parents().closest('td').find('#contact_Id').val();
            			MDB.DPO.Contacts.promptDeleteContact(id, me.parents().closest('tr'));
            		});
            	});

            	$('.dpo-icon-btn.edit').each(function() {
            		var me = $(this);
            		
            		me.click(function(e){
            			var id = me.parents().closest('td').find('#contact_FormAnswerId').val();
            			
            			MDB.DPO.Contacts.loadContactModal(id).done(function () {
            				_modal.modal('show');
            			});
            		});
            	});
            },
            loadContactModal: function(id) {
            	var def = $.Deferred();
            	var body = $(_modal).find('.modal-body');
            	var url;

            	if(id != null) {
            		url = _config.editUrl + '?formAnswerId=' + id;
            	} else {
            		url = _config.createUrl;
            	}

            	body.load(url, function() {
            		MDB.Forms.Index.changeRedirectUrl(_config.contactsUrl);
            		def.resolve();
            	});

            	return def.promise();
            },
            promptDeleteContact: function (id, row) {
            	MDB.promptHtml(
	                MDB.loadResourceString('Dpo_MyAvg_Contact_Delete_Prompt_Title'),
	                '<h4><i class="fa fa-trash text-danger"></i> <small>' + MDB.loadResourceString('Dpo_MyAvg_Contact_Delete_Prompt_Body') + '</small></h4>', 
	                function(ok){
	                    if (ok) {
	            			MDB.sendAjaxRequest(_config.deleteUrl, {id: id}).done(function(response){
	            				console.log('uh. wtf?')
	            				if(response.errors.length == 0) {
	            					MDB.Notify.bootstrapSuccess(MDB.loadResourceString('Dpo_MyAvg_Contact_Delete_Success_Text'));
	            					_table.row(row).remove().draw();
	            				} else {
	            					MDB.Notify.bootstrapDanger(response.errors.join(', '));
	            				}
	            			});
	                    }
	                });
            }
        });
})();